<template>
  <div class="home2">
    <HeroHeader2></HeroHeader2>
    <div class="site-content">
      <CTA3></CTA3>
      <intro></intro>
      <Story></Story>
      <Features2></Features2>
      <Images></Images>
      <CTA2></CTA2>
      <CTA3></CTA3>
      <footer></footer>
    </div>
  </div>
</template>

<script>
import HeroHeader2 from "@/views/Home/HeroHeader2.vue";
import KickstarterCTA from "@/views/Home/KickstarterCTA.vue";
import CTA1 from "@/views/Home/CTA1.vue";
import CTA2 from "@/views/Home/CTA2.vue";
import CTA3 from "@/views/Home/CTA3.vue";
import Footer from "@/views/Home/Footer.vue";
import Features2 from "@/views/Home/Features2.vue";
import Images from "@/views/Home/Images.vue";
import Intro from "@/views/Home/Intro.vue";
import Story from "@/views/Home/Story.vue";
export default {
  name: "Home",
  data() {
    return {
      msg: ""
    };
  },
  components: {
    HeroHeader2,
    CTA1,
    CTA2,
    CTA3,
    Footer,
    Features2,
    Story,
    Intro,
    Images,
    KickstarterCTA
  }
};
</script>

<style>
/* .home2 .site-content {
    margin-top: 50vh;
} */
/* .tooltip{
  opacity: 1 !important;
} */

/* .navbar-brand>img {
    display: block;
    height: 140px;
    width: auto;
} */
.navbar-custom .nav li > a {
  font-size: 17px;
  text-shadow: 1px 1px 1px rgba(26, 30, 33, 0.77);
}
.popover {
  display: block !important;
  color: black;
  width: 100%;
  max-width: 585px;
  padding: 10px;
  height: 105px;
  z-index: 1100;
}
@keyframes zoomIn {
  from {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
}

.vue-popover-theme.open {
  -webkit-animation-name: zoomIn;
  animation-name: zoomIn;
}
.tooltip-inner a:hover {
  color: #01d3f9;
}
.tooltip-inner a {
  color: #01d3f9;
  transition: none;
}
.open a.tooltip-target {
  content: "\F0D7" !important;
}

.tooltip-inner {
  max-width: 100%;
  padding: 3px 8px;
  color: #fff;
  text-align: center;
  background-color: #1073a6;
  border-radius: 4px;
}
.tooltip-inner p {
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
  margin-bottom: 0;
  text-shadow: 1px 1px 2px #081a4269;
  padding: 10px;
  text-align: left;
}
.open a.tooltip-target.b3.active:before {
  content: "\F0D7";
}
.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: 0.5s ease-in-out;
}

.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: fade 0.5s ease-in-out;
}
@media only screen and (max-width: 580px) {
  .popover {
    max-width: 276px;
  }
}
@media only screen and (max-width: 1280px) {
  .dwere-vid iframe {
    width: 80% !important;
    height: 400px !important;
  }
}
@media only screen and (max-width: 500px) {
  .dwere-vid iframe {
    width: 94% !important;
    height: 243px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home/Home2.vue